module.exports = __webpack_public_path__ + "media/bootstrap-icons/img-teste-d180bce6.png";